export * from './encounter-normal-result.service';
